import React, { useState, useContext } from "react";
import AuthContext from "../AuthContext";
import ReportTypeDropdown from "../components/Reports/Select/Type";
import FinancialYearDropdown from "../components/Dropdowns/FinancialYear";
import InvoiceTypeDropdown from "../components/Reports/Select/InvoiceTypes";
import Centre from "../components/Reports/Select/SelectCentre";
import Batch from "../components/Dropdowns/Batch";
import State from '../components/Dropdowns/States';
import District from '../components/Dropdowns/District';
import Status from "../components/Reports/Select/Status";
import Milestone from "../components/Reports/Select/Milestone";
import Scheme from "../components/Reports/Select/SchemeName";
import Sector from "../components/Dropdowns/Sector";
import JobRole from '../components/Reports/Select/JobRole';
import BatchPhase from '../components/Dropdowns/BatchPhase';
import StudentReport from '../components/Reports/Select/CandidateType';
import FY from '../components/Reports/Select/FY';
import MultiCenter from '../components/Reports/Select/CenterMultiSelect'
// tables
import InvoiceTable from "../components/Reports/Tables/Invoice";
import LedgerTable from "../components/Reports/Tables/Ledger";
import StudentTable from "../components/Reports/Tables/Student";
import BatchTable from "../components/Reports/Tables/BatchesReport";
import TCReport from "../components/Reports/Tables/TCReport";
function PurchaseDetails() {
  const authContext = useContext(AuthContext);
  const[selectedCenters,setSelectedCenters]=useState([])
  const [scheme, setScheme] = useState("");
  const [state, setState] = useState("");
  const [sector, setSector] = useState("");
  const [district, setDistrict] = useState("");
  const [batchPhase, setBatchPhase] = useState("");
  const [type, setType] = useState("");
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [selectedInvoiceType, setSelectedInvoiceType] = useState("");
  const [centre, setCentre] = useState("");
  const [batch, setBatch] = useState("");
  const [status, setStatus] = useState("");
  const [milestone, setMilestone] = useState("");
  const [jobRole, setJobRole] = useState("");
  const [reportType, setReportType] = useState("");
  const [start, setStart] = useState('')
  const [end, setEnd] = useState('')
  const [generateClicked, setGenerateClicked] = useState(false)
  const clearFields = () => {
    setState("");
    setDistrict("");
    setBatch("");
    setSector("");
    setJobRole("");
    setBatchPhase("");
    setStatus("");
    setMilestone("");
    setStart("");
    setEnd("");
    setSelectedInvoiceType("");
    setReportType("");
    setSelectedCenters([])
  };
  const handleCentreChange = (e) => {
    setCentre(e.target.value);
    clearFields(); // Clear all related fields
  };
  const handleCenterSelect=(newSelectedCenters)=>{
    setSelectedCenters(newSelectedCenters)
  }
  const handleReportTypeChange = (e) => {
    setType(e.target.value);
    setSelectedFinancialYear('')
    setCentre('')
    setScheme('')
    clearFields()
  };

  const handleFinancialYearChange = (e) => {
    setSelectedFinancialYear(e.target.value);
    clearFields()
  };
  const onResetClicked = () => {
    clearFields();
    setSelectedFinancialYear("");
    setCentre('')
  }
  const handleSchemeChange = (e) => {
    setScheme(e.target.value);
    setJobRole('')
    setState('')
    setDistrict('')
    setBatch('')
    setSector('')
    setBatchPhase('')
  }
  //console.log(centre)
  //console.log(batch)
  const handleGenerateClicked = () => {
    setGenerateClicked(!generateClicked)
  }
  const handleInvoiceTypeChange = (e) => {
    setSelectedInvoiceType(e.target.value);
  };
  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-6 w-full lg:w-11/12 ">
        {/* Dropdown Section */}
        <div className="bg-white p-6 rounded-md shadow-lg border border-gray-300 pt-6">
          <div className="flex flex-col lg:flex-row justify-between gap-6 mb-4">
            {/* Report Type Dropdown */}
            <div className="w-full lg:w-1/5">
              <ReportTypeDropdown type={type} onChange={handleReportTypeChange} />
            </div>


            <>
              {type && type!=='tc' &&
                <div className="w-full lg:w-1/5">
                  <FinancialYearDropdown
                    selectedFinancialYear={selectedFinancialYear}
                    onChange={handleFinancialYearChange}
                  />
                </div>}
{
  type==='tc' && 
  <div className="w-full lg:w-1/5">
                  <FY
                    selectedFinancialYear={selectedFinancialYear}
                    onChange={handleFinancialYearChange}
                  />
                </div>
}
              {/* Centre Dropdown */}

              <>
                {type && type!=='ledger' && <div className="w-full lg:w-1/5">
                  <Centre value={centre} handleInputChange={handleCentreChange} />
                </div>}
                {type ==='ledger' && selectedFinancialYear&& <div className="w-full lg:w-2/5">
                  <MultiCenter selectedCourses={selectedCenters} onChange={handleCenterSelect} />
                </div>}
                {type && type !== "invoice" && type !== 'ledger' && (
                  <div className="w-full lg:w-1/5">
                    <Scheme
                      value={scheme}
                      handleInputChange={handleSchemeChange}
                      centre={centre}
                    />
                  </div>
                )}
              </>

              {/* Invoice Type Dropdown */}
              {type === "invoice" && (
                <>
                  <div className="w-full lg:w-1/5">
                    <InvoiceTypeDropdown
                      selectedInvoiceType={selectedInvoiceType}
                      onChange={handleInvoiceTypeChange}
                    />
                  </div>
                  <div className="w-full lg:w-1/5">
                    <Batch value={batch} handleInputChange={(e) => setBatch(e.target.value)} centre={centre} />
                  </div>
                </>

              )}

              {/* Additional Filters */}
              {(type === "summary" || type === "mis" ||type==='tc') &&
                (
                  <>
                    <div className="w-full lg:w-1/5">
                      <State value={state} handleChange={(e) => setState(e.target.value)} />
                    </div>
                    {type === 'summary' || type==='tc' && 
                      <div className="w-full lg:w-1/5">
                        <District
                          value={district}
                          handleChange={(e) => setDistrict(e.target.value)}
                          selectedState={state}
                        />
                      </div>}
                  </>
                )}
            </>

          </div>
          {selectedInvoiceType === 'status' && (
            <div className="w-full lg:w-1/5">
              <Status value={status} onChange={e => setStatus(e.target.value)} />
            </div>
          )}
          {selectedInvoiceType === 'milestone' && (
            <div className="w-full lg:w-1/5">
              <Milestone value={milestone} onChange={e => setMilestone(e.target.value)} />
            </div>
          )}


          {/* Additional Dropdowns */}
          {(type === "summary" || type === "mis" ||type==='tc') && (
            <div className="flex flex-col lg:flex-row gap-6 mb-4">


              <div className="w-full lg:w-1/5">
                <Sector
                  tc={centre}
                  reports={centre ? true : false}
                  value={sector}
                  handleInputChange={(e) => setSector(e.target.value)}
                />
              </div>
             {type!=='tc' &&(
               <div className="w-full lg:w-1/5">
               <JobRole
                 value={jobRole}
                 handleInputChange={(e) => setJobRole(e.target.value)}
                 centre={centre}
                 sector={sector}
               />
             </div>
             )}
              {type === 'summary' && (
                <>
                  <div className="w-full lg:w-1/5">
                    <label className="block text-gray-700 text-sm font-semibold mb-2">
                      Start Date
                    </label>
                    <input
                      type="date"
                      name="start"
                      id="start"
                      value={start}
                      onChange={(e) => setStart(e.target.value)}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>

                  <div className="w-full lg:w-1/5">
                    <label className="block text-gray-700 text-sm font-semibold mb-2">
                      End Date
                    </label>
                    <input
                      type="date"
                      name="end"
                      id="end"
                      value={end}
                      onChange={(e) => setEnd(e.target.value)}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>
                </>

              )}

              {(scheme && type === 'mis') &&
                <div className="w-full lg:w-1/5">
                  <StudentReport reportType={reportType} onChange={(e) => setReportType(e.target.value)} />
                </div>}

              {(type === 'mis' ||type==='tc') &&
                <div className="w-full lg:w-1/5">
                  <Batch value={batch} handleInputChange={(e) => setBatch(e.target.value)} centre={centre} />
                </div>}
            </div>
          )}
          {(type === "summary") && scheme && (
            <div className="w-full lg:w-1/5">
              <label className="block text-gray-700 text-sm font-semibold mb-2">Batch Type</label>
              <input
                type="text"
                name="batchPhase"
                id="batchPhase"
                value={batchPhase}
                onChange={(e) => setBatchPhase(e.target.value)}
                className="bg-gray-50 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full"
              />
            </div>
          )}
          <div className="flex flex-col lg:flex-row gap-6">

            {type && <>
              <button className="bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
                onClick={handleGenerateClicked}> Generate Report</button>
                {/* <button className="bg-gray-400 text-white font-bold py-2 px-4 rounded mt-4"
                onClick={onResetClicked}> Reset</button> */}

            </>}
          </div>

        </div>

        {/* Table Section */}
        <div>
          {type === "invoice" && (
            <InvoiceTable
              year={selectedFinancialYear}
              centre={centre}
              batch={batch}
              status={status}
              milestone={milestone}
              generateClicked={generateClicked}
            />
          )}
          {type === "ledger" && (
            <LedgerTable year={selectedFinancialYear} centre={selectedCenters} generateClicked={generateClicked} />
          )}
          {(type === "mis") && (
            <StudentTable
              year={selectedFinancialYear}
              centre={centre}
              scheme={scheme}
              sector={sector}
              jobRole={jobRole}
              reportType={reportType}
              batch={batch}
              batchPhase={batchPhase}
              state={state}
              district={district}
              start={start}
              end={end}
              type={type}
              generateClicked={generateClicked}
            />
          )}
          {(type === 'summary') && (
            <BatchTable
              year={selectedFinancialYear}
              centre={centre}
              scheme={scheme}
              sector={sector}
              jobRole={jobRole}
              reportType={reportType}
              batch={batch}
              batchPhase={batchPhase}
              state={state}
              district={district}
              start={start}
              end={end}
              type={type}
              generateClicked={generateClicked}
            />
          )}
          {type==='tc' &&
          <TCReport 
          year={selectedFinancialYear}
          scheme={scheme}
          sector={sector}
          centre={centre}
          state={state}
          batch={batch}
          district={district}
          generateClicked={generateClicked}/>}
        </div>
      </div>
    </div>
  );
}

export default PurchaseDetails;
